<template>
    <div>
        <card-header title="Shirt/Jacket Sizes" icon="fa-tshirt"/>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-sliders-h" title="Report options"/>
                <container-list-item padded>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Report" label-position="inside">
                                <b-select v-model="type" expanded>
                                    <option value="shirts">Participant Sizes</option>
                                    <option value="shirt_summary">Sizes Summary</option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                    <div class="is-size-7 has-text-grey" v-if="type === 'shirts'">
                        One row per traveller with their shirt/jacket size and contact details.
                    </div>
                    <div class="is-size-7 has-text-grey" v-else>
                        Order counts per size, totalled across the trip.
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" @click="generate"><i class="fas fa-file-download mr-2"></i>Generate Report</b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    import {apiUrl} from '@/http_client';
    import {mapGetters} from "vuex";

    // Report options card: pick the filters, then generate. The download
    // itself is the same authenticated GET the other report links use.
    export default {
        props: ['card', 'props'],
        components: {ContainerListItem, SubheaderListItem, CardList, CardFooter, CardBody, CardHeader},
        data: function () {
            return {
                type: 'shirts',
                apiUrl
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            generate() {
                window.open(`${this.apiUrl}api/trips/${this.props.tripId}/reports/${this.type}?auth=${this.currentUser.token}`, '_blank');
            }
        },
        mounted() {
            this.$emit('loading', false);
        }
    };
</script>

<style lang="scss" scoped>

</style>
